import { erpApi } from '@/shared/axios/erp-api';
import { getUrlParamsFetch, handleAxiosError, urlBackend } from '@/shared';
import {
  AlertSeverityEnum,
  GenerarCodigoOtp,
  ICodigoOtp,
  IDataCodigoOtp,
  IDataCodigoOtpParams,
  UseMutationsParams,
  ValidarCodigoOtp,
} from '@/shared/interfaces';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useUiStore } from '@/store/ui';
/**
 * 
*/

const { get, post, put } = erpApi();

//GENERRA CODIGO OTP
export const useFetchGenerarCodigoOtp = () => {
  const queryClient = useQueryClient();
  const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;

  return useMutation({
    mutationFn: generarCodigoOtp,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['codigo-otp'] });
    },
    onError: (e) => {
      setIsGlobalLoading(false);
      handleAxiosError(e);
    }
  });
};

export const generarCodigoOtp = async (data: GenerarCodigoOtp) => {
  const res = await post<IDataCodigoOtp>(
    `${urlBackend}api/v1/enviar-codigo-verificacion/`,
    data,
    true
  );
  return res;
};

//VALIDAR CODIGO OTP
export const usePostValidarCodigoOtp = ({
  enableAlert = true,
}: UseMutationsParams) => {
  const queryClient = useQueryClient();
  const setAlert = useUiStore.getState().setAlert;
  //const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading

  return useMutation({
    mutationFn: postValidarCodigoOtp,
   
    onSuccess: (e) => {
      queryClient.invalidateQueries({ queryKey: ['codigo-otp'] });

      enableAlert && setAlert(true,
        e.message,
        e.status);
    },
    onError: (e) => handleAxiosError(e),
    onSettled: () => {
      //setIsGlobalLoading(false);
    }

  });
};

export const postValidarCodigoOtp = async (data: ValidarCodigoOtp) => {
  const res = await post<IDataCodigoOtp>(
    `${urlBackend}api/v1/validar-codigo-verificacion/`,
    data,
    true
  );
  return res;
};

//OBTENER CODIGO OTP PARA PREVENTAS

export const useGetFetchCodigoOtpSupervisor = (params?: IDataCodigoOtpParams) => {
  return useQuery({
    queryKey: ['codigo-otp', ...Object.values(params || {})],
    queryFn: async () => {
      return obtenerCodigoOtpSupervisor(params);
    },
  });
};

export const obtenerCodigoOtpSupervisor = async (params?: IDataCodigoOtpParams) => {
  const queryParams = getUrlParamsFetch(params || {});

  const res = await get<ICodigoOtp>(
    `${urlBackend}api/v1/codigo-otp/?${queryParams}`,
    true
  );

  return res;
};

//GENERAR UNA SOLICITUD AL SUPERVISOR

export const usePutFetchCodOtp = (
  { enableAlert = true,
  }
    : UseMutationsParams) => {
  const queryClient = useQueryClient();
  const setAlert = useUiStore.getState().setAlert;
  const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;

  return useMutation({
    mutationFn: putCodigoOTP,
    onSuccess: (e) => {
      queryClient.invalidateQueries({ queryKey: ['codigo-otp'] });
      enableAlert && setAlert(true, e.message, e.status);
    },
    onError: (e) => {
      setAlert(true, e.message, AlertSeverityEnum.error);
    },
    onSettled: () => {
      setIsGlobalLoading(false);
    }
  });
};

export const putCodigoOTP = async (data?: IDataCodigoOtpParams) => {
  const res = await put<ICodigoOtp>(
    `${urlBackend}api/v1/codigo-otp/${data?.id_codigo_otp}/`,
    data,
    true
  );
  return res;
};
